import type { KkmExecutionResult } from '@/shared/api';

import { debugAdapterIssue, technicalVendorMessage } from '@/shared/api';
import { sanitizeHtml, useToast } from '@/shared/lib';

/**
 * `Warning`/`Message` успешного ответа ККТ или терминала — оператору одним toast: форма
 * checkout закрывается сразу после успеха, и предупреждение иначе пропадает вместе с ней.
 * Текст готовит `technicalVendorMessage` (без vendor stack, длинные числа замаскированы),
 * а перед `v-html` тостера он проходит `sanitizeHtml`. Сбой показа не меняет исход операции.
 */
export function notifyKkmVendorNotice(result: KkmExecutionResult): void {
  if (result.kind !== 'ok' || (result.response.message === null && result.response.warning === null)) {
    return;
  }

  try {
    const notice = technicalVendorMessage(result.response);

    if (notice !== null) {
      useToast().show(sanitizeHtml(notice));
    }
  } catch (error) {
    debugAdapterIssue('vendor_notice_failed', {
      command: result.response.command,
      technicalErrorType: error instanceof Error ? error.name : typeof error,
    });
  }
}
